import React from 'react';
import {Stack} from "@mui/material";

const ListOfFinishedIntelligence = () => {
    return (
        <Stack p={2} spacing={2} overflow={'auto'}>
            List of Finished Intelligence Page
        </Stack>
    );
};

export default ListOfFinishedIntelligence;